let endpoint = process.env.REACT_APP_API_ENDPOINT;
let stack = endpoint.split('.testinghub.autodesk.com')[0].split('https://')[1];
const endpoints = {
  getNavigationData: {
    url: 'thservices/v1/categories',
  },
  createAccessTestCase: {
    method: 'post',
    url: 'cjt/v1/portal/testcase',
  },
  createTestCase: {
    method: 'post',
    url: 'cjt/v1/:channel/testcase',
  },
  fetchCategoryDataQuarry: {
    url: 'cjt/v1/categories?categoryid=:id&limit=11011',
  },
  fetchChannelList: {
    url: 'cjt/v1/categories?categoryid=:categoryid&limit=11011&subcategoryid=:channelid',
  },
  fetchNextDataSet: {
    url: ':url',
  },
  getCustomOrders: {
    url: 'testdata/v1/mydata?status=:filter&limit=:limit',
  },
  getCustomTestCases: {
    url: 'cjt/v1/mytestcases?:query',
  },
  getQuarryChannels: {
    url: 'testdata/v1/:category',
  },
  getQuarryTestCases: {
    url: 'testdata/v1/:category?subcategoryid=:channel&limit=11011&env=:env',
  },
  getProducts: {
    url: 'testdata/v1/getproducts?intendedUsage=:channelName&env=:env&limit=300',
  },
  getPublicKey: {
    url: 'encryption/v1/publickey',
  },
  getQuarryTestCaseFields: {
    url: 'testdata/v1/:category?subcategoryid=:channel&metafield=:metafield&env=:env',
  },
  getQuarryProductFields: {
    url: 'testdata/v1/:category?subcategoryid=:channel&materialcode=:materialcode&env=:env',
  },
  getMeshTestCaseFields: {
    url: 'cjt/v1/categories?subcategoryid=:channel&metafield=:metafield',
  },
  getMyMeshTestCases: {
    url: 'cjt/v1/mytestcases?limit=:limit',
  },
  getMyQuarryOrders: {
    url: 'testdata/v1/mydata?limit=:limit',
  },
  getQuarrySKUs: {
    url: '/testdata/v1/sku/:type?fulfillmentType=:fulfillment&region=:region&channel=:channel&env=:env&limit=50&offset=0',
  },
  submitOrderToQuarry: {
    method: 'post',
    url: 'testdata/:version/:channel/order',
  },
  submitOrderToNewBuying: {
    method: 'post',
    url: 'testdata/v1/submitorder',
  },

  // Hosting
  getHostingProjects: {
    url: 'hosting/v1/org/:org/workstream/:workstream/project',
  },
  getHostingProject: {
    url: 'hosting/v1/org/:org/workstream/:workstream/project/:project',
  },
  getHostingProjectTestCases: {
    url: 'hosting/v1/org/:org/workstream/:workstream/project/:project/testcase',
  },
  getHostingProjectTestCase: {
    url: 'hosting/v1/org/:org/workstream/:workstream/project/:project/testcase/:testcase',
  },
  postHostingProjectTestCase: {
    method: 'post',
    url: 'hosting/v1/project/:project/testcase',
  },
  postHostingNewProject: {
    method: 'post',
    url: 'hosting/v1/onboard/project',
  },
  putHostingEditProject: {
    method: 'put',
    url: 'hosting/v1/onboard/project/:project',
  },
  deleteHostingProject: {
    method: 'delete',
    url: 'hosting/v1/onboard/workstream/:workstream/project/:project',
  },
  postHostingNewTestCase: {
    method: 'post',
    url: 'hosting/v1/onboard/testcase',
  },
  putHostingEditTestCase: {
    method: 'put',
    url: 'hosting/v1/onboard/workstream/:workstream/project/:project/testcase/:testcase',
  },
  deleteHostingTestCase: {
    method: 'delete',
    url: 'hosting/v1/onboard/workstream/:workstream/project/:project/testcase/:testcase',
  },
  postHostingCreateTestDataFile: {
    method: 'post',
    url: 'hosting/v1/onboard/s3/:workstream/:project/:testcase/:rowname?env=:env&filetype=:filetype',
  },
  postHostingCreateExecutionTestDataFile: {
    method: 'post',
    url: 'hosting/v1/execution/s3/:workstream/:project/:testcase?env=:env&filetype=:filetype',
  },
  deleteHostingTestDataFile: {
    method: 'delete',
    url: ':uri',
  },
  postHostingCreateTestData: {
    method: 'post',
    url: 'hosting/v1/onboard/testdata',
  },
  getGlobalFields: {
    url: '/hosting/v1/org/:org/workstream/:workstream/globalfields',
  },
  postGlobalFields: {
    method: 'post',
    url: '/hosting/v1/org/:org/workstream/:workstream/globalfields',
  },

  // Git Branches
  getGitBranches: {
    url: 'hosting/v1/org/:org/workstream/:workstream/gitbranches',
  },
  postGitBranches: {
    method: 'post',
    url: 'hosting/v1/org/:org/workstream/:workstream/gitbranches',
  },
  deleteGitBranches: {
    method: 'delete',
    url: 'hosting/v1/org/:org/workstream/:workstream/gitbranches',
  },

  // GitHub Integration
  postGitHubFetchTestCases: {
    method: 'post',
    url: 'github/v1/fetchTestCases',
  },
  postGitHubAccessToken: {
    method: 'post',
    url: 'github/v1/accessToken',
  },


  // Jobs queue page
  getHostingExecutions: {
    url: 'hosting/v1/myexecutions/:org?limit=:limit:query',
  },
  getTestCaseStatus: {
    url: 'cjt/v1/status/:id?:query',
  },
  getTestDataStatus: {
    url: 'testdata/v1/status/:id',
  },
  getHostingStatus: {
    url: 'hosting/v1/status/:executionid?transactionid=:id',
  },
  getHostingExecutionStatus: {
    url: ':service/v1/status/:executionid',
  },
  postHostingAbortTransactions: {
    method: 'post',
    url: 'hosting/v1/abort/execution/:executionid',
  },
  postPublishReports: {
    method: 'post',
    url: 'report/v1/publish/:service',
  },
  postPublishToJIRA: {
    method: 'post',
    url: 'jira/v1/publish/:service',
  },
  deleteExecutionTransactions: {
    method: 'delete',
    url: 'execution/v1/:service/:executionid',
  },

  getTestDataExecutionStatus: {
    url: 'testdata/v1/execution/status/:executionid?transactionid=:transactionid',
  },

  getCJTExecutionStatus: {
    url: 'cjt/v1/execution/status/:executionid?transactionid=:transactionid',
  },

  // Test Suites
  getTestSuites: {
    url: 'suites/v1/testsuites/:service',
  },
  getTestSuite: {
    url: 'suites/v1/testsuite/:id',
  },
  postNewTestSuite: {
    method: 'post',
    url: 'suites/v1/testsuites/:service',
  },
  postPublishTestSuite: {
    method: 'post',
    url: 'suites/v1/testsuite/publish/:id',
  },
  putUpdateTestSuite: {
    method: 'put',
    url: 'suites/v1/testsuite/:id',
  },
  getServiceEnvironments: {
    url: 'suites/v1/env/:service',
  },
  getScreenshot: {
    url: 'screenshot/' + stack + '-screenshots-bucket/:screenshotname',
  },
  getPlaywrightReport: {
    url: 'hosting/v1/playwright/report/:executionid?reporttype=:reportType',
  },
  getPlaywrightReportTransaction: {
    url: 'hosting/v1/playwright/report/:executionid?transactionid=:transactionid&reporttype=:reportType',
  },
  deleteTestSuite: {
    method: 'delete',
    url: '/suites/v1/testsuite/:testsuiteid',
  },
  getSharedExecutions: {
    url: 'shared/v1/execution/:service?limit=:limit:query',
  },
  postResubmit: {
    method: 'post',
    url: 'resubmit/v1/:service/:executionid:query',
  },
  putTestSuiteSchedule: {
    method: 'put',
    url: 'suites/v1/testsuite/schedule/:id',
  },
  deleteTestSuiteSchedule: {
    method: 'delete',
    url: 'suites/v1/testsuite/schedule/:id',
  },
  postRunTestSuite: {
    method: 'post',
    url: 'suites/v1/testsuite/:id',
  },
  getMasterData: {
    url: 'datastore/masterdata',
  },
  getSearchDataStores: {
    url: 'datastore/testdata/:category/:subCategory/:env/:store?dataage=:dataAge&dataage_end=:dataAgeEnd',
  },
  claimTestDataStore: {
    method: 'patch',
    url: 'datastore/testdata/claim',
  },
  getClaimList: {
    url: 'datastore/testdata/claim',
  },
  getOfferingProducts: {
    url: 'offerings/:env/:usageType?pricingMethod=:pricingMethod&limit=1000&offset=0',
  },
  getAccountStoreFields: {
    url: 'accountservice/v1/getstorefields',
  },
  getUserAccounts: {
    url: 'accountservice/v1/getuseraccounts',
  },
  getOrCreateAccounts: {
    method: 'post',
    url: 'accountservice/v1/createaccount',
  },
  unClaimAccount: {
    method: 'put',
    url: 'accountservice/v1/unclaim',
  },
  inviteUser: {
    method: 'post',
    url: 'accountservice/v1/inviteuser',
  },
  emailSearch: {
    method: 'post',
    url: 'tools/emails/search',
  },
  emailForward: {
    method: 'post',
    url: 'tools/emails/forward',
  },
  getRecentlyExecutedJobs: {
    url: 'dashboard/v1/data?teamname=:teamName&startdate=:startDate&enddate=:endDate&limit=:limit&datatype=get_recently_executed_jobs&executedby=:executedBy&org=:org&workstream=:workstream&project=:project',
  },
  getNumberOfJobExecuted: {
    url: 'dashboard/v1/data?teamname=:teamName&startdate=:startDate&enddate=:endDate&datatype=get_number_of_job_executed&executedby=:executedBy&org=:org&workstream=:workstream&project=:project',
  },
  getTopMostFailures: {
    url: 'dashboard/v1/data?teamname=:teamName&startdate=:startDate&enddate=:endDate&limit=:limit&datatype=get_top_failure_messages&executedby=:executedBy&org=:org&workstream=:workstream&project=:project',
  },
  getTopFailingJobs: {
    url: 'dashboard/v1/data?teamname=:teamName&startdate=:startDate&enddate=:endDate&limit=:limit&datatype=get_top_failing_jobs&executedby=:executedBy&org=:org&workstream=:workstream&project=:project',
  },
  getNumberOfJobs: {
    url: 'dashboard/v1/data?datatype=get_number_of_job&org=:org&workstream=:workstream&project=:project',
  },
  getNumberOfTestSuites: {
    url: 'dashboard/v1/data?datatype=get_number_of_testsuites&org=:org&workstream=:workstream&project=:project',
  },
  getTestsuiteExecutions: {
    url: 'dashboard/v1/data?datatype=get_testsuite_executions&org=:org&workstream=:workstream&project=:project&startdate=:startDate&enddate=:endDate',
  },
  getExecutionIterationDetails: {
    url: 'dashboard/v1/data?datatype=get_execution_iteration_details&org=:org&workstream=:workstream&project=:project&startdate=:startDate&enddate=:endDate',
  },
  getExecutionAnalytics: {
    method: 'post',
    url: 'ai/v1/analysis/execution',
  },
  updateErrorGroupCategory: {
    method: 'post',
    url: 'ai/v1/error-category/:org/:workstream',
  },
  getLastRefreshTime: {
    url: 'dashboard/v1/data?datatype=get_last_refresh_time',
  },
  
  // Chatbot / AutoQ
  getChatSessions: {
    url: 'mcp/chat/sessions/',
  },
  getChatSessionMessages: {
    url: 'mcp/chat/sessions/:sessionId',
  },
  sendChatHelpRequest: {
    url: 'mcp/chat/help',
    method: 'POST',
  },
};

export default endpoints;
